import { toImageCdnUrl } from "src/utilities/images"

export enum ProductImageSize {
  Huge = 1024 * 2,
  Large = 640 * 2,
  Tiny = 200,
}

export function toProductImageCdnUrl(src: string | null | undefined, size: ProductImageSize) {
  return toImageCdnUrl(src, { w: size, h: size, fit: "contain" })
}
